import getProp from '@f/get-prop'
import setProp from '@f/set-prop'
import { parse } from 'component-querystring'

let preloadedState = {}

const { oauth } = parse(window.location.search.slice(1))
if (oauth) {
  try {
    let { settings, error: oauthError, provider } = JSON.parse(window.atob(oauth))

    // Format oauthErrors
    if (oauthError) {
      oauthError = {
        title: 'Authentication Error',
        message: 'We were unable to authenticate your account.'
      }
    }

    preloadedState = setProp('application.setup', preloadedState, {
      isHidden: false,
      type: 'source'
    })

    preloadedState = setProp('application.sourceSetup', preloadedState, {
      sourceSlug: provider,
      step: 'connect',
      oauthError,
      source: { settings }
    })

    preloadedState = setProp('oauth', preloadedState, {
      [provider]: {
        oauthError,
        settings
      }
    })

    // Remove oauth querystring from URL
    // I'd much rather this live somewhere else and keep `preloaded-state` pure
    if (getProp('history.replaceState', window)) window.history.replaceState({}, '', window.location.pathname)
  } catch (err) {
    // ignore
  }
}

// load auth flow flags
const isInAuthFlow = window.localStorage.getItem('isInAuthFlow')
if (isInAuthFlow) {
  window.localStorage.removeItem('isInAuthFlow')
  preloadedState.oauth = preloadedState.oauth || {}
  preloadedState.oauth = setProp('localStorageFlags', preloadedState.oauth, { isInAuthFlow, shouldBeSuccessful: true })
}

const { user, workspace, lockout } = window.segment || {}
if (user) {
  preloadedState.currentUser = { ...user }
}

if (workspace) {
  preloadedState = setProp('application.page.currentWorkspaceSlug', preloadedState, workspace.slug)
  preloadedState.workspacesBySlug = {
    hasRequested: true,
    data: {
      [workspace.slug]: {
        hasRequested: true,
        data: { ...workspace }
      }
    }
  }
}

if (workspace && workspace.billing) {
  preloadedState.billingByWorkspaceSlug = {
    hasRequested: true,
    [workspace.slug]: {
      hasRequested: true,
      data: workspace.billing
    }
  }
}

if (workspace && lockout) {
  preloadedState = setProp(`lockouts.data.${workspace.slug}`, preloadedState, { ...lockout })
}

export default preloadedState



// WEBPACK FOOTER //
// ./store/preloaded-state.js